/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-01-15 15:27:26
 * @LastEditors: hexy
 * @LastEditTime: 2024-09-05 15:30:16
 * @Description: 善建云通主数据
 * @FilePath: \PCMS-Share\src\views\ShareSystem\api\mainHx.js
 */
import request from '@/utils/request'

// 秘钥登录
export function cardLogin_HX(params) {
    return request({
        url: '/MainPlatform/userLogin/cardLogin',
        method: 'post',
        data: params
    })
}


// 员工下拉框
export function getUserList_HX(params) {
    return request({
        url: `/MainPlatform/travel/employee/queryList?accessToken=${params}`,
        method: 'post'
    })
}

// 集团字典
export function getDict_HX(params, token) {
    return request({
        url: `/MainPlatform/travel/dict/query_page`,
        method: 'post',
        data: params,
        token: token,
    })
}

// 主数据根据编码查组织
export function personOrgs_HX(params, token) {
    return request({
        url: `/MainPlatform/travel/employee/personOrgs`,
        method: 'post',
        data: params,
        token: token,
    })
}

// 主数据根据编码查组织
export function getProjects_HX(params, token) {
    return request({
        url: `/MainPlatform/travel/main-non-construction-projects/query_page`,
        method: 'post',
        data: params,
        token: token,
    })
}

// 主数据分页获取客商档案数据
export function getSupplier_HX(params, token) {
    return request({
        url: `/MainPlatform/travel/supplier/query_page`,
        method: 'post',
        data: params,
        token: token,
    })
}
// 获取结算里项目
export function getProject_HX(params,token) {
    return request({
        url: `/MainPlatform/travel/main-non-construction-projects/query_page`,
        method: 'post',
        data: params,
        token: token,
    })
}
// 获取业务大小类名称
export function getCategory(params,token) {
    return request({
        url: `/MainPlatform/travel/dictGXBusiness/query_category`,
        method: 'post',
        data: params,
        token: token,
    })
}
// 获取明细客户
export function queryProfitDetail(params,token) {
    return request({
        url: `/MainPlatform/travel/main-profit-center/query_page`,
        method: 'post',
        data: params,
        token: token,
    })
}
// 获取共享项目
export function queryProject(params,token) {
    return request({
        url: `/MainPlatform/travel/main-non-construction-projects/query_page`,
        method: 'post',
        data: params,
        token: token,
    })
}
// 获取收入报账单查询
export function queryGXReceive(params) {
    return request({
        url: `/grasspond/jtgx/queryGXReceive`,
        method: 'post',
        data: params,
    })
}
// 获取收入报账单明细查询
export function queryGXReceiveDetail(params) {
    return request({
        url: `/grasspond/jtgx/queryGXReceiveDetail`,
        method: 'post',
        data: params,
    })
}
// 推送、重推（批量推送 1根据账期和主体推2根据明细推）
export function send2GXReceive(params) {
    return request({
        url: `/grasspond/jtgx/send2GXReceive`,
        method: 'post',
        data: params,
    })
}
// 获取业务记账单查询
export function queryGXCost(params) {
    return request({
        url: `/grasspond/jtgx/queryGXCost`,
        method: 'post',
        data: params,
    })
}
// 获取业务记账单明细查询
export function queryGXCostDetail(params) {
    return request({
        url: `/grasspond/jtgx/queryGXCostDetail`,
        method: 'post',
        data: params,
    })
}
// 业务记账单-生成明细
export function generateGXCost(params) {
    return request({
        url: `/grasspond/jtgx/generateGXCost`,
        method: 'post',
        data: params,
    })
}
// 推送、重推（批量推送 1根据账期和主体推2根据明细推）
export function send2GXCost(params) {
    return request({
        url: `/grasspond/jtgx/send2GXCost`,
        method: 'post',
        data: params,
    })
}
// 业务记账单-删除影像
export function removeGXCost(params) {
    return request({
        url: `/grasspond/jtgx/removeGXCost`,
        method: 'post',
        data: params,
    })
}
// 业务记账单-保存
export function saveGXCost(params) {
    return request({
        url: `/grasspond/jtgx/saveGXCost`,
        method: 'post',
        data: params,
    })
}
// 业务记账单-审核更新状态
export function updateGXCostState(params) {
    return request({
        url: `/grasspond/jtgx/updateGXCostState`,
        method: 'post',
        data: params,
    })
}
// 业务记账单-查询锁定状态
export function queryCostBusinessState(params) {
    return request({
        url: `/grasspond/jtgx/queryCostBusinessState`,
        method: 'post',
        data: params,
    })
}
// 收入报账单-查询锁定状态
export function queryHasImage(params) {
    return request({
        url: `/grasspond/business-sales-month/hasImage`,
        method: 'post',
        data: params,
    })
}

// 业务记账单-查询原始报表明细
export function queryGXCostDetailOriginal(params) {
    return request({
        url: `/grasspond/jtgx/queryGXCostDetailOriginal`,
        method: 'post',
        data: params,
    })
}
//收入报账-查询原始报表明细（销售月报）
export function queryGXReceiveDetailOriginal(params) {
    return request({
        url: `/grasspond/jtgx/queryGXReceiveDetailOriginal`,
        method: 'post',
        data: params,
    })
}
//收入报账-置为草稿）
export function updateGXReceiveCheckStatus(params) {
    return request({
        url: `/grasspond/jtgx/updateGXReceiveCheckStatus`,
        method: 'post',
        data: params,
    })
}
//收入报账-更新附件
export function updateGXReceiveFile(params) {
    return request({
        url: `/grasspond/jtgx/updateGXReceiveFile`,
        method: 'post',
        data: params,
    })
}
//业务记账-更新附件
export function updateFileUrl(params) {
    return request({
        url: `/grasspond/jtgx/updateFileUrl`,
        method: 'post',
        data: params,
    })
}
//业务记账-只增加附件
export function addGxCostFile(params) {
    return request({
        url: `/grasspond/jtgx/addGxCostFile`,
        method: 'post',
        data: params,
    })
}
//收入报账-只增加附件
export function addGXReceiveFile(params) {
    return request({
        url: `/grasspond/jtgx/addGXReceiveFile`,
        method: 'post',
        data: params,
    })
}
//分页获取行政管理数据
export function getOrganization_HX(params,token) {
    return request({
        url: `/MainPlatform/travel/administrative_organization/query_page`,
        method: 'post',
        data: params,
        token:token,
    })
}